import { ReactNode } from "react";
import classNames from "classnames";
import css from "./Tooltip.module.css";

interface TooltipProps {
	text: string;
	children: ReactNode;
	position?: "top" | "bottom" | "right" | "left";
}

const Tooltip = ({ text, children, position = "right" }: TooltipProps) => {
	return (
		<div className={css.tooltip}>
			{children}
			<span
				className={classNames(css.tooltiptext, {
					[css.tooltipRight]: position == "right",
					[css.tooltipLeft]: position == "left",
					[css.tooltipTop]: position == "top",
					[css.tooltipBottom]: position == "bottom",
				})}
			>
				{text}
			</span>
		</div>
	);
};

export default Tooltip;
